"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('uikit/modules/loader',['underscore', 'marionette', '../mixins/component.mixin', '../templates', '../channel', '../extra/size'], function (_, Mn, ComponentMixin, Templates, channel, Size) {
  var Loader = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui loader',
    template: Templates.UIKit['loader'],
    options: {
      active: false,
      inline: false,
      centered: false,
      floated: null,
      text: '',
      size: ''
    },
    sizeOptionValues: _.values(Size),
    update: _defineProperty(_defineProperty({
      size: false,
      inline: false,
      centered: false,
      active: false
    }, "size", false), "floated", false),
    bindings: {},
    updateAttributes: function updateAttributes() {
      this.addClass('active', this.getBoolOption('active')).addClass('disabled', !this.getBoolOption('active')).addClass('text', this.getBoolOption('text')).addClass('centered', this.getBoolOption('centered')).addClass('inline', this.getBoolOption('inline')).addClass(this.getOption('floated') + ' floated', this.getBoolOption('floated')).addClass(this.getOption('size'));
    }
  });
  channel.reply('loader', function () {
    return Loader;
  });
  return Loader;
});

